// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Dobrev IT Ltd

import { CheckOutlined } from "@ant-design/icons";
import type { MenuProps } from "antd";
import type { VideoQuality } from "../rtc";
import type { BgMode } from "../bgeffect";

const check = (on: boolean) => (on ? <CheckOutlined /> : <span style={{ display: "inline-block", width: 12 }} />);

const QUALITIES: VideoQuality[] = ["auto", "high", "medium", "low"];
const LABEL: Record<VideoQuality, string> = { auto: "Auto", high: "High", medium: "Medium", low: "Low" };

// qualityMenuGroup is the "Video quality" group for the in-call device dropdown (shared by
// CallView + GroupCallView). "Auto" lets the browser adapt freely; the rest cap bandwidth.
export function qualityMenuGroup(current: VideoQuality, onSelect: (q: VideoQuality) => void): NonNullable<MenuProps["items"]>[number] {
  return {
    key: "quality-group",
    type: "group",
    label: "Video quality",
    children: QUALITIES.map((q) => ({ key: q, label: LABEL[q], icon: check(q === current), onClick: () => onSelect(q) })),
  };
}

// backgroundMenuGroup is the "Background" group (None / Blur) for the in-call device menu.
export function backgroundMenuGroup(current: BgMode, onSelect: (m: BgMode) => void): NonNullable<MenuProps["items"]>[number] {
  const opts: [BgMode, string][] = [
    ["none", "None"],
    ["blur", "Blur background"],
  ];
  return {
    key: "bg-group",
    type: "group",
    label: "Background",
    children: opts.map(([m, label]) => ({ key: `bg-${m}`, label, icon: check(m === current), onClick: () => onSelect(m) })),
  };
}
